export default __webpack_public_path__ + "static/7-59603d58080964c0d541fdba1735996b.png";